import { P3Campaign as IP3Campaign, ThomasAdvertiser } from 'models/interfaces';
import { P3Configuration } from './interfaces/P3Configurations';

class P3Campaign implements IP3Campaign {
  public p3_campaign_id: string = '';
  public tgrams_id: string = '';
  public p3_configuration_id: string = '';
  public name: string = '';
  public advertiser?: ThomasAdvertiser;
  public p3_configuration?: P3Configuration;
  public entitled_rank_points: number = 0;
  public entitled_coverage_areas: number = 0;
  public entitled_preview_ads: number = 0;
  public start_date: string = '';
  public end_date: string = '';
  public last_updated_by?: string;
  public last_updated_date?: string;
  public created_by?: string;
  public created_date?: string;

  public static fromP3CampaignConfiguration(
    p3Campaign: IP3Campaign,
    p3Configuration: P3Configuration
  ) {
    const newCampaign = new P3Campaign();

    // set these values from existing p3Campaign
    newCampaign.p3_campaign_id = p3Campaign.p3_campaign_id;
    newCampaign.tgrams_id = p3Campaign.advertiser ? p3Campaign.advertiser.tgrams_id : '';
    newCampaign.name = p3Campaign.name;
    newCampaign.start_date = p3Campaign.start_date;
    newCampaign.end_date = p3Campaign.end_date;
    newCampaign.tgrams_id = p3Campaign.tgrams_id;

    // set these values from existing p3Configuration
    newCampaign.p3_configuration_id = p3Configuration.p3_configuration_id;
    newCampaign.entitled_rank_points = p3Campaign.entitled_rank_points; //configurationValidPoints(p3Configuration);
    newCampaign.entitled_coverage_areas = p3Configuration.coverage_areas;
    newCampaign.entitled_preview_ads = p3Configuration.preview_ads;

    return newCampaign;
  }

  public static makeP3CampaignInput(p3Campaign: IP3Campaign, statusId?: number) {
    // basically build an object with all the values except created_date, created_by, etc
    const newCampaign = {
      p3_campaign_id: p3Campaign.p3_campaign_id,
      tgrams_id: p3Campaign.tgrams_id,
      p3_configuration_id: p3Campaign.p3_configuration_id,
      name: p3Campaign.name,
      entitled_rank_points: p3Campaign.entitled_rank_points,
      entitled_coverage_areas: p3Campaign.entitled_coverage_areas,
      entitled_preview_ads: p3Campaign.entitled_preview_ads,
      start_date: p3Campaign.start_date,
      end_date: p3Campaign.end_date
    };

    return newCampaign;
  }

  /**
   * P3Campaign has a configuration if the p3_configuration object is set on the p3Campaign
   */
  public static hasConfiguration = (p3Campaign: IP3Campaign) => !!p3Campaign.p3_configuration;

  /**
   * Configuration is from a template if the configuration exists and there is no
   * P3CampaignId assigned to the configuration
   */
  public static configurationIsTemplate = (p3Campaign: IP3Campaign) => {
    console.log(
      `is configurationTemplate`,
      p3Campaign.p3_configuration && !p3Campaign.p3_configuration.p3_campaign_id
    );
    return p3Campaign.p3_configuration && !p3Campaign.p3_configuration.p3_campaign_id;
  };

  public makeP3CampaignInput() {
    // basically build an object with all the values except created_date, created_by, etc
    const newCampaign = {
      p3_campaign_id: this.p3_campaign_id,
      tgrams_id: this.tgrams_id,
      p3_configuration_id: this.p3_configuration_id,
      name: this.name,
      entitled_rank_points: this.entitled_rank_points,
      entitled_coverage_areas: this.entitled_coverage_areas,
      entitled_preview_ads: this.entitled_preview_ads,
      start_date: this.start_date,
      end_date: this.end_date
    };

    return newCampaign;
  }
}

export default P3Campaign;
